import React from "react"
import { Box, Heading, Flex, Link } from "@chakra-ui/react"
import ReactSlick from "react-slick"
import { Container } from "../layout/Container"
import { Image } from "../image/Image"
import { CTA } from "../section/CTA"
import { Headline } from "../section/Headline"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./slider.css"

export function LogoItem({ logo, url }) {
  return (
    <Box minHeight="93px" p="0 10px">
      {logo?.localFile?.childImageSharp && (
        <Box maxWidth="200px" margin="0 auto">
          <Link
            css={{
              width: `100%`,
              height: `auto`,
              bg: `white`,
            }}
            href={url}
            target="_blank"
          >
            <Image
              style={{ alignSelf: "center" }}
              image={logo.localFile.childImageSharp}
            />
          </Link>
        </Box>
      )}
    </Box>
  )
}

export function LogoCarousel({
  title,
  logos,
  hideCta = false,
  cta,
  ctaLink,
  titleColor = `black`,
  backgroundColor,
  ctaColor,
  ctaBasis = `auto`,
  isEnabled,
  sectionTitle,
  sectionSubtitle,
}) {
  if (!isEnabled) {
    return null
  }

  const settings = {
    dots: true,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 5,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 1090,
        settings: {
          slidesToShow: 3,
          arrows: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 3,
          arrows: false,
          dots: true,
        },
      },
    ],
  }

  return (
    <Box bg={backgroundColor}>
      <Container>
        {sectionTitle && (
          <Box mb="40px">
            <Headline title={sectionTitle} description={sectionSubtitle} />
          </Box>
        )}

        {title && (
          <Heading
            fontSize="20px"
            lineHeight="30px"
            color={titleColor}
            textTransform="uppercase"
            textAlign="center"
            fontWeight={600}
            m="0 0 30px"
          >
            {title}
          </Heading>
        )}
        <Box
          maxWidth={`${140 * logos?.length + 200}px`}
          m="0 auto"
          className="mojo-slider-container"
        >
          <ReactSlick {...settings}>
            {logos &&
              logos.length > 0 &&
              logos.map(({ logo, url }, index) => {
                return <LogoItem key={index} logo={logo} url={url} />
              })}
          </ReactSlick>
        </Box>
        {cta && !hideCta && (
          <Flex textAlign="center" justifyContent="center" mt="24px">
            <Box alignSelf="center" flexBasis={ctaBasis}>
              <Box pl="24px">
                <CTA
                  large
                  color={ctaColor}
                  cta={cta}
                  ctaLink={ctaLink || ""}
                  internalLink={ctaLink?.startsWith("/")}
                />
              </Box>
            </Box>
          </Flex>
        )}
      </Container>
    </Box>
  )
}
